/**
 * XtAxios 对 rfapi（xt4：含 rc）会把 Promise resolve 成 response.data.result，
 * 因此这里拿到的已是「原先 JSON 里的 result 对象」，不要再读 .result.items。
 * 兼容：列表在 items / list / records / rows、或 result 直接为数组、或仍嵌套一层 result。
 */
export function pickRfapiPagedList(res) {
  if (res == null) return { items: [], hasNext: false };
  if (Array.isArray(res)) {
    return { items: res, hasNext: false };
  }
  if (typeof res !== "object") return { items: [], hasNext: false };

  const tryRows = (node) => {
    if (!node || typeof node !== "object") return null;
    if (Array.isArray(node)) return node;
    const keys = ["items", "list", "records", "rows", "data"];
    for (const k of keys) {
      if (Array.isArray(node[k])) return node[k];
    }
    return null;
  };

  const direct = tryRows(res);
  if (direct) {
    return {
      items: direct,
      hasNext: Boolean(res.hasNext ?? res.has_next ?? res.nextPage),
    };
  }

  const inner = res.result;
  if (inner != null) {
    if (Array.isArray(inner)) {
      return { items: inner, hasNext: false };
    }
    const nested = tryRows(inner);
    if (nested) {
      return {
        items: nested,
        hasNext: Boolean(inner.hasNext ?? inner.has_next ?? inner.nextPage),
      };
    }
  }

  return { items: [], hasNext: false };
}
